import { render, staticRenderFns } from "./TwoPhaseGASetting.vue?vue&type=template&id=3c96335a&scoped=true"
import script from "./TwoPhaseGASetting.vue?vue&type=script&lang=js"
export * from "./TwoPhaseGASetting.vue?vue&type=script&lang=js"
import style0 from "./TwoPhaseGASetting.vue?vue&type=style&index=0&id=3c96335a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c96335a",
  null
  
)

export default component.exports